exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pickup-address-status{position:absolute;top:0px;right:-10px;z-index:99}.pickup-address-status>img{width:70px;height:auto;margin-top:-10px}", ""]);

// exports
